/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable no-alert */
import React, { useRef } from 'react';
import { DialogUtility } from '@syncfusion/ej2-popups';
import { TextAreaComponent, TextBoxComponent } from '@syncfusion/ej2-react-inputs';
import { ButtonComponent } from '@syncfusion/ej2-react-buttons';
// import { MultiSelectComponent, DropDownListComponent, CheckBoxSelection, Inject } from '@syncfusion/ej2-react-dropdowns';
import Navbar from './Navbar1';
import Footer1 from './Footer1';
import UserFAQ from './UserFAQ';
import kit from '../data/logo.png';

const Support = () => {
  const { REACT_APP_API_ENDPOINT } = process.env;
  async function sendEmail(email, to, subject, message) {
    if (email && email.length > 5 && email.includes('@') && email.includes('.')) {
      fetch(`${REACT_APP_API_ENDPOINT}/email?recipient=${email}&to=${to}&subject=${subject}&message=${message}<br />Monaco Support Form:<br />Please send me more information`, {
        method: 'GET',
        headers: {
        },
      })
        .then((response) => response.json())
        .then((responseJson) => {
          if (responseJson && responseJson.response && responseJson.response === 'OK') {
            DialogUtility.alert('Your request has been sent. Thank you for your interest!');
          } else {
            DialogUtility.alert(responseJson.response);
          }
        })
        .catch((error) => {
          console.error(error);
        });
    } else {
      DialogUtility.alert('Please enter a valid email address!');
    }
  }
  const messageRef = useRef(null);
  const submitEmail = () => {
    const email = document.getElementById('email').value;
    // const to = 'bbarrs@zackatlabs.com';
    const to = 'developer@zackat.com';
    const first = document.getElementById('first').value;
    const last = document.getElementById('last').value;
    const phone = document.getElementById('phone').value;
    // const company = document.getElementById('company').value;
    const subject = 'ZackatLabs Mobile App Support';
    const name = `${first} ${last}`;
    let msg = '';
    if (!email || email.length === 0 || !email.includes('@') || !email.includes('.')) {
      DialogUtility.alert('Please enter a valid email address!');
      return;
    }
    if (!phone || phone.length === 0) {
      DialogUtility.alert('Please enter a valid phone number!');
      return;
    }
    if (messageRef && messageRef.current) {
      msg = messageRef.current.value;
    }
    let message = 'Support question regarding ZackatLabs/Sensocore Mobile App';
    message += `<br />${name}`;
    if (msg && msg.length > 0) {
      // message = `Name: ${name}<br />Company: ${company}<br />US State: ${location}\n<br />Services requested: ${services}<br />Customer Message: ${msg}`;
      message = `Name: ${name}<br />Customer Support Message: ${msg}`;
    }
    sendEmail(email, to, subject, message);
  };
  return (
    <div className="home-container">
      <div className="nav-bar-bg">
        <Navbar />
      </div>
      <div className="contact-page-wrapper">
        <UserFAQ dt="Knowledge Base" />
        <h4 className="primary-heading">Do you have a question regarding the ZackatLabs/Sensocore Mobile App?</h4>
        <div className="flex">
          <label>CONTACT OUR SUPPORT STAFF</label>
        </div>
        <div className="contact-form-wrapper" style={{ border: 'solid 2px', borderColor: '#78DA89', borderRadius: 10, backgroundColor: 'white' }}>
          <img src={kit} width={140} />
          <font color="red">*</font> indicates required fields
          <div className="flex">
            <label htmlFor="name">Name<font color="red">*</font></label>
            <TextBoxComponent
              value=""
              id="first"
              required
              name="first"
              placeholder="First"
              cssClass="e-outline"
              floatLabelType="Auto"
            />
            <TextBoxComponent
              value=""
              id="last"
              name="last"
              required
              placeholder="Last"
              cssClass="e-outline"
              floatLabelType="Auto"
            />
          </div>

          <div className="flex">
            <label htmlFor="email">Email<font color="red">*</font></label>
            <TextBoxComponent
              value=""
              id="email"
              required
              name="email"
              cssClass="e-outline"
              placeholder="Email"
              floatLabelType="Auto"
            />
            <label htmlFor="phone">Phone<font color="red">*</font></label>
            <TextBoxComponent
              value=""
              id="phone"
              required
              name="phone"
              placeholder="Phone"
              cssClass="e-outline"
              floatLabelType="Auto"
            />
          </div>
          <div className="flex mt-4">
            <label htmlFor="name">Message</label>
            <TextAreaComponent
              ref={messageRef}
              rows={5}
              maxLength={200}
              id="message"
              title="message"
              placeholder="Message"
              cssClass="e-outline"
              floatLabelType="Auto"
              value=""
            />
          </div>
          <div className="flex-end mr-4">
            <ButtonComponent cssClass="e-small" iconCss="e-icons e-save" style={{ float: 'right' }} onClick={submitEmail}>Submit</ButtonComponent>
          </div>
        </div>
      </div>
      <Footer1 />
    </div>
  );
};
export default Support;
